module.exports = __webpack_public_path__ + "img/manchestore-banner.7461c145.png";